module.exports = function getAddressString(
	{
		address_line1,
		address_line2,
		administrative_area,
		country_code,
		locality,
		postal_code,
	},
	exclude = ["country_code", "postal_code"]
) {
	let addressString = "";
	if (address_line1) {
		addressString += address_line1;
	}
	if (address_line2) {
		addressString += ", " + address_line2;
	}
	if (locality) {
		addressString += ", " + locality;
	}
	if (administrative_area) {
		addressString += ", " + administrative_area;
	}
	if (postal_code && !exclude.includes("postal_code")) {
		addressString += ", " + postal_code;
	}
	if (country_code && !exclude.includes("country_code")) {
		addressString += ", " + country_code;
	}
	return `${addressString}.`;
};
